export const eventTargetOrAncestorContainsClass = (event: MouseEvent, className: string) => {
  if (event.target instanceof Element) {
    return event.target.closest(`.${className}`) !== null;
  }
  return false;
};
